import { createSelector } from "reselect";
import { getIsParentLocation } from "./getIsParentLocation";
import { getIsPosSyncSupported } from "./getPosMenuSupported";

export const showSettingsFilter = createSelector(
    getIsParentLocation,
    getIsPosSyncSupported,
    (isParentLocation, isPosSyncSupported) => (isParentLocation ? isPosSyncSupported ?? false : true)
);
